export { Error as ErrorPage } from './error-page';
